import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

import { environment } from '@environments/environment';
import { finalize } from 'rxjs/operators';

import { DependenteService } from '@app/shared/services/dependente.service';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { TipoDependenciaService } from '@app/shared/services/tipo-dependencia.service';
import { UtilService } from './../../../../../shared/services/util.service';
import { ValidarRequiredFormService } from '@app/shared/services';

import { Dependente, Loading, ChaveValor, ConfigCamposFormulario, Censo } from '@app/shared/models';
import { MotivoDependenciaOptions } from '@app/shared/models/enums/motivo-dependencia.enum';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-adicionar-dependente',
  templateUrl: './adicionar-dependente.component.html',
  styleUrls: ['./adicionar-dependente.component.scss']
})
export class AdicionarDependenteComponent {

  carregar = new Loading();
  cliente = environment.cliente;

  form: FormGroup;
  tiposDependente: ChaveValor[] = [];
  configCamposFormulario: ConfigCamposFormulario[];
  enumMotivoDependencia = MotivoDependenciaOptions;
  censo: Censo;

  constructor(
    public dialogRef: MatDialogRef<AdicionarDependenteComponent>,
    private dependenteService: DependenteService,
    private fb: FormBuilder,
    private mensagemService: MensagemService,
    private tipoDependenciaService: TipoDependenciaService,
    private utilService: UtilService,
    private validarRequiredFormService: ValidarRequiredFormService,
    private censoService: CensoService,
    @Inject(MAT_DIALOG_DATA) public data: { dependente: Dependente, listaDependentes: Dependente[], segurado: any, configCamposFormulario: ConfigCamposFormulario[] }
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.configCamposFormulario = data.configCamposFormulario;
    console.log('data: ', data);


    this.form = this.fb.group({
      nome: [null],
      cpf: [null, [(control: AbstractControl) => this.utilService.validatorsCustomCPF(control)]],
      dataNascimento: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      nomeMae: [null],
      id: [null],
      tipoDependencia: [null],
      finsImpostoRenda: [false],
      finsPrevidenciarios: [false],
      motivoInicioDependencia: [null],
      dataInicio: [null]
    });

    this.definirValidatorRequiredNosCampos();
    this.buscarTiposDependencia();

    if (data.dependente != null) {
      this.form.patchValue({
        ...data.dependente,
        dataNascimento: this.utilService.formatarDataBR(data.dependente.dataNascimento),
        dataInicio: this.utilService.formatarDataBR(data.dependente.dataInicio),
        motivoInicioDependencia: data?.dependente?.motivoInicioDependencia?.id,
        tipoDependencia: data.dependente.tipoDependencia.id
      });
    }
  }

  definirValidatorRequiredNosCampos(): void {
    this.validarRequiredFormService.definirValidatorRequiredNosCampos(this.form, this.configCamposFormulario);
  }

  salvar(): void {
    this.form = this.utilService.verificarForm(this.form);

    if (this.form.invalid) return this.mensagemService.avisoFormularioInvalido();

    if (this.data.segurado.cpf == this.form.value.cpf) {
      return this.mensagemService.avisoMensagemAlerta('CPF já cadastrado.');
    }

    if (
      this.form.value.id == null &&
      this.data.listaDependentes.filter(d => d.cpf == this.form.value.cpf).length > 0
    ) {
      return this.mensagemService.avisoMensagemAlerta('CPF já cadastrado.');
    }

    this.carregar.load = true
    this.dependenteService.postOrPut(this.formSalvar)
      .pipe(finalize(() => this.carregar.load = false))
      .subscribe(value => {
        this.dialogRef.close(value);
      });
  }

  get formSalvar(): Dependente {
    return {
      ...this.form.value,
      dataNascimento: this.utilService.formatarDataPadraoHTML(this.form.get('dataNascimento').value),
      dataInicio: this.utilService.formatarDataPadraoHTML(this.form.get('dataInicio').value),
      tipoDependencia: this.getObjetoTipoDependente()
    };
  }

  isRequired(campo: string): any {
    return this.utilService.isRequiredField(campo, this.form)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    return this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel;
  }

  private getObjetoTipoDependente() {
    const id = Number(this.form.get('tipoDependencia').value);
    return this.tiposDependente.find(v => v.id === id) || null;
  }

  private buscarTiposDependencia(): void {
    this.tipoDependenciaService.get(this.carregar).subscribe(values => this.tiposDependente = values);
  }

}
